var map = {
	"./altramuces.png": "a029",
	"./apio.png": "37f3",
	"./cacahuate.png": "c096",
	"./crustaceo.png": "9900",
	"./dioxido.png": "9eca",
	"./frutos.png": "4063",
	"./gluten.png": "2d91",
	"./huevo.png": "7bcc",
	"./lacteo.png": "c68f",
	"./moluscos.png": "9de6",
	"./mostaza.png": "e4c1",
	"./pescado.png": "7377",
	"./proteina-leche.png": "9cd8",
	"./sesamo.png": "da4a",
	"./soja.png": "c264"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bc5b";